import React, { useEffect, useState } from "react";
import "../ForgotPassword/ForgotPassword.css";
import kuberimgpassword from "../../../Assets/Images/forgotpass.png";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { Apiurl } from "../../../Utils/utils";
import FloatingLabelInput from "../../../Components/floatingLabel/FloatingLabel";
import Loader from "../../../Components/loader/loader";
import { Modal } from "react-bootstrap";

const ForgotPassword = () => {
  const [timer, setTimer] = useState(60);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  console.log(isButtonDisabled,"isButtonDisabled");
  const [isResendButtonDisabled, setIsResendButtonDisabled] = useState(false);
  const [showModalNew, setShowModalNew] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [emailforgot, setEmailforgot] = useState();
  const [error, setError] = useState(false);

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  function isValidEmail(emailforgot) {
    return emailRegex.test(emailforgot);
  }

  const validate = () => {
    if (!emailforgot) {
      setError(true);
      return false;
    }
    if (!isValidEmail(emailforgot)) {
      toast.error("Please enter a valid email");
      return false;
    }
    return true;
  };

  const handleLoginNavigate = () => {
    navigate("/");
  };

  const handleSendEmail = (e) => {
    e?.preventDefault();
    if (!validate()) return;
    setLoading(true);

    const data = {};
    data.Email = emailforgot;
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
      },
      url: `${Apiurl()}/Account/ForgotPassword`,
      data: { data: JSON.stringify(data) },
    };

    axios(option)
      .then((response) => {
        setLoading(false);

        if (response?.status === 200) {
          toast.success(response?.data?.message)
          setEmailforgot("");
          setError(false);
          setTimer(60);
          setIsButtonDisabled(true);
          setTimeout(() => {
            setIsButtonDisabled(false);
          }, 60000);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleResendEmail = () => {
    setIsResendButtonDisabled(true);
    setTimer(60);

    setTimeout(() => {
      setIsResendButtonDisabled(false);
    }, 60000);
  };

  const handleCloseModal = () => {
    setShowModalNew(false);
  };

  useEffect(() => {
    let interval;

    if (isButtonDisabled) {
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer === 1) {
            setIsButtonDisabled(false);
            clearInterval(interval);
          }
          return prevTimer - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [isButtonDisabled]);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="full-page-main-forgot">
        <div className="main-container-of-login-page-forgot row-12">
          <div className="login-page-image-forgot col-6">
            <img src={kuberimgpassword} alt="" />
          </div>
          <div className="login-page-form-forgot col-6">
            <div className="inner-container-of-login-form-forgot">
              <h2 className="resetpass-forgotpage"> Reset Password </h2>
              <div className="need-a-accoount-forgot">
                <p>Let Us Help You</p>
              </div>
              <span className="enter-your-registered-email-address">
                Enter your registered email address.
              </span>
              <form onSubmit={(e) => handleSendEmail(e)}>
                <div className="email-and-password-inputs-forgot">
                  <div>
                    <div className="username-content-forgot">
                      <FloatingLabelInput
                        label="Email*"
                        type="text"
                        value={emailforgot}
                        onChange={(e) => setEmailforgot(e.target.value)}
                        onBlur={(e) => {
                          if (!e.target.value) {
                            setError(true);
                          } else {
                            setError(false);
                          }
                        }}
                      />
                      {error && !emailforgot ? (
                        <span className="contact_error-forgot">
                          Email is required.
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="login-button-forgot">
                  <button
                    type="submit"
                    style={{
                      backgroundColor: emailforgot
                        ? "#3f51b5"
                        : "rgba(0, 0, 0, .12)",
                      color: emailforgot ? "#fff" : "rgba(0, 0, 0, .38)",
                    }}
                  >
                    Reset My Password
                  </button>
                </div>
                <div className="login-in-fogot-password">
                  <a href="" onClick={handleLoginNavigate}>
                    Login?
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {showModalNew && (
        <Modal
          show={showModalNew}
          onHide={handleCloseModal}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            {/* <Modal.Title>Cancel Confirmation</Modal.Title> */}
          </Modal.Header>
          <Modal.Body>
            <div className="textarea-validate">
              Forgot password request submitted successfully. An email has been
              sent to your email id
            </div>
          </Modal.Body>
          <Modal.Footer className="Delete-fotter-forgot">
            <button
              onClick={handleResendEmail}
              disabled={isResendButtonDisabled}
              style={{ cursor: isResendButtonDisabled ? "not-allowed" : "pointer" }}
            >
              {isResendButtonDisabled
                ? `Resend Email (${timer}s remaining)`
                : "Resend Email"}
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default ForgotPassword;
